module.exports = __webpack_public_path__ + "assets/img/Group_260@2x.8b9b6e61.png";